import { BaseSliceController } from '@Base/slices/slices.base';
import { AssistantsRequester } from '../Services/Assistants.Requester';
import { Assistants } from '../Types/Assistants.types';

export class AssistantsSlice extends BaseSliceController<
	Assistants,
	'Assistants',
	Assistants
> {
	private static instance: AssistantsSlice;
	static getInstance() {
		if (!AssistantsSlice.instance) {
			AssistantsSlice.instance = new AssistantsSlice();
		}
		return AssistantsSlice.instance;
	}
	constructor() {
		super('Assistants', AssistantsRequester.getInstance());
	}
}

export const {
	assistantsGetAll,
	assistantsDeleteById,
	assistantsToggleActive,
	assistantsGetSingle,
} = AssistantsSlice.getInstance().getActions();
